// Translate-knop naast "Lees voor" (Views/Partials/components/readspeaker.cshtml): opent de uitleg
// "How to translate text" (Views/Partials/components/translateHelp.cshtml, één <dialog> per pagina).
// Vertalen zelf gaat via ReadSpeaker (tekst selecteren → 'Vertalen'); zonder ReadSpeaker blijft de knop verborgen.
// Sluiten: kruisje, Escape (standaard bij <dialog>) of klik naast de pop-up.
const dialog = document.getElementById('rs-translate-help') as HTMLDialogElement | null;
const buttons = Array.from(document.querySelectorAll<HTMLElement>('.js-rs-translate'));
const readSpeakerLoaded = !!(window as any).rspkr;

if (dialog && typeof dialog.showModal === 'function' && readSpeakerLoaded) {
    let opener: HTMLElement | null = null;

    for (const button of buttons) {
        button.hidden = false;
        button.setAttribute('aria-controls', dialog.id);
        button.addEventListener('click', () => {
            opener = button;
            dialog.showModal();
        });
    }

    const close = dialog.querySelector<HTMLElement>('.js-rs-translate-close');
    if (close) { close.addEventListener('click', () => dialog.close()); }

    // Klik op de achtergrond (buiten de inhoud) sluit de pop-up
    dialog.addEventListener('click', (event) => {
        if (event.target === dialog) { dialog.close(); }
    });

    // Focus terug naar de knop waarmee de pop-up geopend werd
    dialog.addEventListener('close', () => {
        if (opener) { opener.focus(); }
    });
}

export {};
